import React, { Component } from 'react';

import './CurrentCharts.css';
import { withNamespaces, Trans } from 'react-i18next';

class CurrentCharts extends Component {
  setIcon = (category) => {
    if(this.props.categories.length){
      let discipline = this.props.categories.find(i => i.name === category);
      return (discipline.icon);
    }
  }
  setCategoryName = (category) => {
    if(this.props.categories.length){
      let discipline = this.props.categories.find(i => i.name === category);
      return (discipline.displayName);
    }
  }

  render() {
    const { t } = this.props;
    let frequentActivitiesList;

    if(this.props.data){
      let mostFrequentActivities = this.props.data.thisMonth.mostFrequentActivities;
      let thisMonthPoints = this.props.data.thisMonth.points;
      frequentActivitiesList = mostFrequentActivities.slice(0,6).map( i =>

        <div className="CurrentCharts__stats-category" key={i.discipline}>
          <div className="CurrentCharts__stats-category__icon">
            <img src={this.setIcon(i.discipline)} alt={this.setCategoryName(i.discipline)} title={this.setCategoryName(i.discipline)} />
          </div>
          <div className="CurrentCharts__stats-category__progress">
            <div className="CurrentCharts__stats-category__progress-bar" style={{ width : (i.points / thisMonthPoints)*100 + '%' }}></div>
            <div className="CurrentCharts__stats-category__progress-value">{i.points} pt</div>
          </div>
        </div>
      )
    }


    return (
      <div className="CurrentCharts">
        <div className="CurrentCharts__container container">

          <h2 className="CurrentCharts__header Header"><strong className="flames">{t('We do sports')}</strong></h2>
          <h4>{t('Current month')}</h4>
          <div className="CurrentCharts__stats">

            <div className="CurrentCharts__stats-overall">
              <div className="CurrentCharts__stats-trainings CurrentCharts__stats-block">
                <div className="CurrentCharts__stats-trainings__value CurrentCharts__stats-block__value">{(this.props.data ? this.props.data.thisMonth.numberOfTrainings : 0)}</div>
                <div className="CurrentCharts__stats-trainings__text CurrentCharts__stats-block__text"><Trans i18nKey="Training sessions">Training<br/>sessions</Trans></div>
              </div>
              <div className="CurrentCharts__stats-engagement CurrentCharts__stats-block">
                <div className="CurrentCharts__stats-engagement__value CurrentCharts__stats-block__value">{(this.props.data ? this.props.data.thisMonth.percentOfEngagedEmployees : 0)}%</div>
                <div className="CurrentCharts__stats-engagement__text CurrentCharts__stats-block__text"><Trans i18nKey="NoAIgnite engaged">Employees<br/>engaged</Trans></div>
              </div>
              <div className="CurrentCharts__stats-money CurrentCharts__stats-block">
                <div className="CurrentCharts__stats-money__value CurrentCharts__stats-block__value">{(this.props.data ? this.props.data.thisMonth.money : 0)} zł</div>
                <div className="CurrentCharts__stats-money__text CurrentCharts__stats-block__text">{t('This month so far')}</div>
              </div>
            </div>

            <div className="CurrentCharts__stats-specific">
              {frequentActivitiesList}
            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default withNamespaces()(CurrentCharts);



// WEBPACK FOOTER //
// ./src/screens/home/CurrentCharts/CurrentCharts.js